import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Table from "../../../core/common/dataTable/index";
import { Modal } from "react-bootstrap";
import { Pagination } from "antd";
import CollapseHeader from "../../../core/common/collapse-header";
import { all_routes } from "../../router/all_routes";
import { getPricebooks, addPricebook, updatePricebook, deletePricebook, getPricebookDetail, getProductDetail, addProductPriceBook, deleteProductPriceBook, getAllPricebooks, getAllProducts, getProductPriceBookDetail, updateProductPriceBook, updateProduct } from "./pricebookAPI";
import ResponseModal from "../../../core/modals/response_modal";
interface Product {
  id: number;
  productName: string;
  price: number;
}
interface ProductDetail {
  id: number;
  name: string;
  description: string;
  code: string;
  category: string;
  createdBy: string;
  createdDate: string;
  updatedBy: string;
  updatedDate: string;
  related: {id: number; productId: string; productName: string; productPrice: string; priceBookId: number; priceBookName: string }[];
}
interface Pricebook {
  id: number;
  uuid: string;
  name: string;
  createdBy: string;
  createdDate: string;
  updatedBy: string;
  updatedDate: string;
}
interface PricebookProduct {
  id: number;
  name: string;
  createdBy: string;
  createdAt: string;
  updatedBy: string;
  updatedAt: string;
  productRelated: {
    id: number;
    productId: number;
    productName: string;
    productPrice: number;
    priceBookId: number;
    priceBookName: string;
  }[];
}
interface ProductPriceBook {
  id: number;
  uuid: string;
  productId: number;
  priceBookId: number;
  price: number;
  createdBy: string;
  createdDate: string;
  updatedBy: string;
  updatedDate: string;
}
interface PricebookForm {
  name: string;
}

interface PricebookListRequest {
  pageNo: number;
  pageSize: number;
  property?: string;
  direction?: "ASC" | "DESC";
  name?: string;
}
interface RelatedProduct {
  id: number;
  productId: number;
  productName: string;
  productPrice: number;
  priceBookId: number;
  priceBookName: string;
}
const PricebookList = () => {
  const route = all_routes;

  // State for pricebook list
  const [response, setResponse] = useState<{ status: "success" | "error"; message: string } | null>(null);
  const [showProductsModal, setShowProductsModal] = useState(false);
  const [showPriceModal, setShowPriceModal] = useState(false);
  const [selectedProductsWithPrice, setSelectedProductsWithPrice] = useState<{
    productId: number;
    productName: string;
    productPrice: number;
  }[]>([]);
  const [selectedPricebookProducts, setSelectedPricebookProducts] = useState<PricebookProduct[]>([]);
  const [selectedPricebookName, setSelectedPricebookName] = useState<string>("");
  const [showEditProductModal, setShowEditProductModal] = useState(false);
  const [showDeleteProductModal, setShowDeleteProductModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState<ProductDetail>();
  const [editedProduct, setEditedProduct] = useState({
    productName: "",
    productDescription: "",
    productPrice : 0,
    productCode: "",
    productCategory: ""
  });
  const [showAddProductModal, setShowAddProductModal] = useState(false);
  const [showMessageModal, setShowMessageModal] = useState(false);
  const [addingProducts, setAddingProducts] = useState(false);
  const [products, setProducts] = useState<Product[]>([]);
  const [selectedProductIds, setSelectedProductIds] = useState<number[]>([]);
  const [selectedProductPriceBookId, setSelectedProductPriceBookId] = useState<number | null>(null);
  const [selectedPricebookId, setSelectedPricebookId] = useState<number | null>(null);
  const [loading, setLoading] = useState(false);
  const [newProduct, setNewProduct] = useState({
    productName: "",
    productPrice: 0
  });
  const [data, setData] = useState<Pricebook[]>([]);

  // State forr filter
  const [filters, setFilters] = useState<PricebookListRequest>({
    pageNo: 0,
    pageSize: 10,
    property: "id",
    direction: "ASC",
    name: "",
  });

  // State for paging
  const [pagination, setPagination] = useState({
    totalPages: 1,
    totalElements: 0,
  });

  // State for add PB form
  const [newPricebook, setNewPricebook] = useState<PricebookForm>({
    name: "",
  });

  // State for edit form
  const [editingPricebook, setEditingPricebook] = useState<Pricebook | null>(null);
  const [editedPricebookId, setEditedPricebookId] = useState<number | null>(null);

  // State for model confirm delete
  const [pricebookToDelete, setPricebookToDelete] = useState<{ id: number; name: string } | null>(null);

  // State cho modal thông báo thành công khi thêm mới
  const [openModal, setOpenModal] = useState(false);
  const [createdPricebookId, setCreatedPricebookId] = useState<number | null>(null);

  // State cho modal thông báo thành công khi chỉnh sửa
  const [openEditSuccessModal, setOpenEditSuccessModal] = useState(false);

  // State for loading product detail
  const [loadingProductDetail, setLoadingProductDetail] = useState(false);

  // Hàm xử lý khi thay đổi giá trị trong filter
  const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFilters((prevFilters) => ({
      ...prevFilters,
      [name]: value,
    }));
  };
  const handlePricebookNameClick = async (pricebookId: number, pricebookName: string) => {
    setSelectedPricebookId(pricebookId);
    setSelectedPricebookName(pricebookName);
    await fetchPriceBookDetail(pricebookId);
    setShowProductsModal(true);
  };
  const fetchPriceBookDetail = async (pricebookId: number) => {
    try {
      const response = await getPricebookDetail(pricebookId);
      if (response.data && response.data.data) {
        setSelectedPricebookProducts([response.data.data]);
        return response.data.data;
      }
      return null;
    } catch (error) {
      console.error("Error fetching pricebook details:", error);
      return null;
    }
  };
  // Hàm xử lý khi thay đổi thứ tự sắp xếp
  const handleSortChange = async (property: string, direction: "ASC" | "DESC") => {
    try {
      const newDirection = filters.direction === "ASC" ? "DESC" : "ASC";

      const updatedFilters = {
        ...filters,
        property,
        direction: newDirection as "ASC" | "DESC"
      };

      setFilters(updatedFilters);

      const response = await getPricebooks(updatedFilters);

      if (response.data && response.data.data) {
        setData(response.data.data.content || []);
        setPagination({
          totalPages: response.data.data.totalPages || 1,
          totalElements: response.data.data.totalElements || 0,
        });
      }
    } catch (error) {
      console.error("Error loading sorted pricebook list:", error);
    }
  };

  const handleAddSelectedProducts = () => {
    const selectedProducts = products
      .filter(product => selectedProductIds.includes(product.id))
      .map(product => ({
        productId: product.id,
        productName: product.productName,
        productPrice: 0
      }));

    setSelectedProductsWithPrice(selectedProducts);
    setShowAddProductModal(false);
    setShowPriceModal(true);
  };
  const handleAddProductsWithPrice = async () => {
    if(!selectedPricebookId){
      return;
    }
    try {
      const productsToAdd = selectedProductsWithPrice.map(product => ({
        productId: Number(product.productId),
        priceBookId: Number(selectedPricebookProducts[0]?.id),
        price: Number(product.productPrice)
      }));
      const apiResponse = await addProductPriceBook(productsToAdd);

      if (apiResponse.status === 200) {
        setResponse({
          status: "success",
          message: "Products added successfully!"
        });
        fetchPriceBookDetail(selectedPricebookId);
        setSelectedProductIds([]);
        setSelectedProductsWithPrice([]);
        setShowPriceModal(false);
      }
    } catch (error: any) {
      console.error("Error adding products:", error);
      setResponse({
        status: "error",
        message: error.response?.data?.message || "Error adding products"
      });
    } finally {
      setShowMessageModal(true);
    }
  };
  const handleProductSelect = (productId: number) => {
    setSelectedProductIds(prev => {
      if (prev.includes(productId)) {
        return prev.filter(id => id !== productId);
      } else {
        return [...prev, productId];
      }
    });
  };
  const handlePriceChange = (productId: number, price: number) => {
    setSelectedProductsWithPrice(prev =>
      prev.map(product =>
        product.productId === productId
          ? { ...product, productPrice: price }
          : product
      )
    );
  };
  // Sửa lại các hàm xử lý
  const handleEditProduct = async (productId: number) => {
    try {
      setLoadingProductDetail(true);
      const response = await getProductDetail(productId);
      if (response.data && response.data.data) {
        const productDetail = response.data.data;
        setSelectedProduct(productDetail);
        const selectedRelated = productDetail.related.find((r: RelatedProduct) => r.priceBookId === selectedPricebookId);
        setEditedProduct({
          productName: productDetail.name || "",
          productDescription: productDetail.description || "",
          productPrice : selectedRelated.productPrice,
          productCategory: productDetail.category || "",
          productCode: productDetail.code || ""
        });
        setShowEditProductModal(true);
      }
    } catch (error) {
      console.error("Error fetching product details:", error);
      setResponse({
        status: "error",
        message: "Error fetching product details"
      });
      setShowMessageModal(true);
    } finally {
      setLoadingProductDetail(false);
    }
  };

  const handleDeleteProductFromPriceBook = (productPriceBookId: number) => {
    setSelectedProductPriceBookId(productPriceBookId);
    setShowDeleteProductModal(true);
  };
  const getValueUpdateProduct = async () => {
    return {
      productName: editedProduct.productName,
      productDescription: editedProduct.productDescription,
      productCode: editedProduct.productCode,
      productCategory: editedProduct.productCategory
    }
  }
  const getUpdateProductPriceValue = async () => {
    return {
      price : editedProduct.productPrice
    }
  }
  const handleUpdateProduct = async () => {
    try {
      if (!selectedProduct || !selectedPricebookId) return;
      const updateData = await getValueUpdateProduct();
      // const newProductPriceBookprice = await getUpdateProductPriceValue();
      // const updatePriceResponse = await updateProductPriceBook
      const response = await updateProduct(selectedProduct.id, updateData);
      if (response.status === 200) {
        setResponse({
          status: "success",
          message: "Product updated successfully!"
        });
        await fetchPriceBookDetail(selectedPricebookId);
        setShowEditProductModal(false);
        setShowMessageModal(true);
      }
    } catch (error: any) {
      console.error("Error updating product:", error);
      setResponse({
        status: "error",
        message: error.response?.data?.message || "Error updating product"
      });
      setShowMessageModal(true);
    }
  };

  const handleInputUpdateProductChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setEditedProduct((prevState) => {
      if (!prevState) return prevState;
      return {
        ...prevState,
        [name]: value
      };
    });
  };
  const handleConfirmDeleteProduct = async () => {
    if (!selectedProductPriceBookId || !selectedPricebookId) return;
    try {
      const response = await deleteProductPriceBook(selectedProductPriceBookId);
      if (response.status === 200) {
        const updatedProducts = selectedPricebookProducts[0]?.productRelated.filter(
          product => product.productId !== selectedProduct?.id
        );
        setSelectedPricebookProducts([{
          ...selectedPricebookProducts[0],
          productRelated: updatedProducts
        }]);
        setResponse({
          status: "success",
          message: "Product removed from pricebook successfully!"
        });
        await fetchPriceBookDetail(selectedPricebookId);
        setShowDeleteProductModal(false);
        setSelectedProductPriceBookId(null);
      }
    } catch (error: any) {
      console.error("Error deleting product:", error);
      setResponse({
        status: "error",
        message: error.response?.data?.message || "Error deleting product"
      });
    } finally {
      setShowMessageModal(true);
    }
  };
  // Hàm áp dụng filter
  const applyFilters = async () => {
    try {
      setFilters((prevFilters) => {
        const updatedFilters = { ...prevFilters, pageNo: 0 };
        console.log("Reset pageNo before sending filters:", updatedFilters);
        return updatedFilters;
      });

      const response = await getPricebooks({ ...filters, pageNo: 0 });

      console.log("Received response:", response.data);
      setData(response.data.data.content || []);
      setPagination({
        ...pagination,
        totalElements: response.data.data.totalElements,
        totalPages: response.data.data.totalPages
      });
    } catch (error) {
      console.error("Error getting pricebook list with filters:", error);
    }
  };

  // Hàm xử lý khi thay đổi trang
  const handlePageChange = (newPage: number) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      pageNo: newPage,
    }));
    fetchPricebooks(newPage);
  };
  const fetchProducts = async () => {
    try {
      setLoading(true);
      const response = await getAllProducts();
      setProducts(response.data.data);
    } catch (error) {
      console.error("Error fetching products:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (showAddProductModal) {
      fetchProducts();
    }
  }, [showAddProductModal]);

  // Hàm lấy danh sách pricebook
  const fetchPricebooks = async (page: number = 0) => {
    try {
      const response = await getPricebooks({ ...filters, pageNo: page });
      console.log("API Response:", response.data);

      if (response.data && response.data.data && response.data.data.content) {
        const pricebooks = response.data.data.content.map((pricebook: any) => ({
          id: pricebook.id,
          uuid: pricebook.uuid,
          name: pricebook.name,
          createdBy: pricebook.createdBy || null,
          createdDate: pricebook.createdDate || null,
          updatedBy: pricebook.updatedBy || null,
          updatedDate: pricebook.updatedDate || null
        }));

        setData(pricebooks);
        setPagination({
          totalPages: response.data.data.totalPages || 1,
          totalElements: response.data.data.totalElements || 0,
        });
      } else {
        console.error("Invalid API response:", response.data);
        setData([]);
      }
    } catch (error) {
      console.error("Error fetching pricebook list:", error);
      setData([]);
    }
  };

  // Hàm xử lý khi thay đổi giá trị trong form thêm/sửa
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;

    // Cập nhật state cho form thêm mới
    setNewPricebook(prevState => ({
      ...prevState,
      [name]: value
    }));

    // Cập nhật state cho form chỉnh sửa
    setEditingPricebook((prevState) => {
      if (!prevState) return prevState;
      return {
        ...prevState,
        [name]: value,
      };
    });
  };

  // Hàm tạo mới pricebook
  const handleCreatePricebook = async () => {
    try {
      if (!newPricebook.name) {
        console.error("Missing required information: Pricebook name");
        setResponse({ status: "error", message: "Please fill in all required fields: Pricebook name" });
        return;
      }

      const pricebookData = {
        name: newPricebook.name.trim()
      };

      console.log("Pricebook data before sending to API:", pricebookData);

      const response = await addPricebook(pricebookData);
      console.log("API Response:", response.data);

      if (response.status === 200) {
        const createdId = response.data.data.id;
        console.log("Pricebook created successfully with ID:", createdId);
        setCreatedPricebookId(createdId);
        setOpenModal(true);

        await fetchPricebooks(0);

        setNewPricebook({
          name: "",
        });
      }
    } catch (error: any) {
      console.error("Error creating pricebook:", error);
      setResponse({ status: "error", message: "Error creating pricebook: " + (error.response?.data?.message || error.message) });
    } finally {
      setShowMessageModal(true);
    }
  };

  // Hàm xử lý khi click nút chỉnh sửa
  const handleEditClick = async (pricebookId: number) => {
    console.log("Pricebook ID:", pricebookId);
    try {
      const response = await getPricebookDetail(pricebookId);
      console.log("API response:", response.data.data);

      if (response.status === 200) {
        setEditingPricebook(response.data.data);
        setEditedPricebookId(response.data.data.id);
      }
    } catch (error) {
      console.error("Error fetching pricebook details:", error);
    }
  };

  // Hàm cập nhật pricebook
  const handleUpdatePricebook = async () => {
    if (!editingPricebook?.id) {
      console.error("Error: No valid ID found for update!", editingPricebook);
      return;
    }

    try {
      console.log("Updating pricebook with ID:", editingPricebook.id);

      const updatedPricebook = {
        name: editingPricebook.name
      };

      console.log("Sending pricebook update data:", updatedPricebook);
      const response = await updatePricebook(editingPricebook.id, updatedPricebook);

      if (response.status === 200) {
        console.log("Pricebook updated successfully");
        setEditedPricebookId(editingPricebook.id);
        setOpenEditSuccessModal(true);
        fetchPricebooks(0);
      }
    } catch (error: any) {
      console.error("Error updating pricebook:", error);
      const errorMessage = error.response?.data?.message || error.message || "Unknown error";
      setResponse({ status: "error", message: "Error updating pricebook: " + errorMessage });
    } finally {
      setShowMessageModal(true);
    }
  };

  // Hàm xử lý khi click nút xóa
  const handleDeleteClick = (id: number, name: string) => {
    setPricebookToDelete({ id, name });
  };

  // Hàm xóa pricebook

  const handleConfirmDelete = async () => {
    if (!pricebookToDelete) return;

    try {
      const response = await deletePricebook(pricebookToDelete.id);
      if (response.status === 200) {
        setData(prev => prev.filter(pricebook => pricebook.id !== pricebookToDelete.id));
        setResponse({
          status: "success",
          message: `Pricebook "${pricebookToDelete.name}" has been deleted successfully!`
        });
      } else {
        setResponse({
          status: "error",
          message: response.data?.message || "Failed to delete pricebook"
        });
      }
    } catch (error: any) {
      console.error("Error deleting pricebook:", error);
      setResponse({
        status: "error",
        message: error.response?.data?.message || "Error deleting pricebook"
      });
    } finally {
      setShowMessageModal(true);
    }

  };
  // Lấy danh sách pricebook khi component được load
  useEffect(() => {
    fetchPricebooks();
  }, []);

  // Định nghĩa các cột cho bảng
  const columns = [
    {
      title: "Pricebook Name",
      dataIndex: "name",
      key: "name",
      render: (text: string, record: Pricebook) => (
        <Link
          to="#"
          className="title-name"
          onClick={(e) => {
            e.preventDefault();
            handlePricebookNameClick(record.id, text);
          }}
        >
          {text}
        </Link>
      ),
      sorter: (a: Pricebook, b: Pricebook) => a.name.localeCompare(b.name),
    },
    {
      title: "Created Date",
      dataIndex: "createdDate",
      key: "createdDate",
      render: (date: string) => new Date(date).toLocaleDateString(),
      sorter: (a: Pricebook, b: Pricebook) => new Date(a.createdDate).getTime() - new Date(b.createdDate).getTime(),
    },
    {
      title: "Created By",
      dataIndex: "createdBy",
      key: "createdBy",
    },
    {
      title: "Updated Date",
      dataIndex: "updatedDate",
      key: "updatedDate",
      render: (date: string) => new Date(date).toLocaleDateString(),
    },
    {
      title: "Updated By",
      dataIndex: "updatedBy",
      key: "updatedBy",
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (_: unknown, record: Pricebook) => (
        <div className="dropdown table-action">
          <Link
            to="#"
            className="action-icon"
            data-bs-toggle="dropdown"
            aria-expanded="true"
          >
            <i className="fa fa-ellipsis-v"></i>
          </Link>
          <div
            className="dropdown-menu dropdown-menu-right"
            style={{
              position: "absolute",
              inset: "0px auto auto 0px",
              margin: "0px",
              transform: "translate3d(-99.3333px, 35.3333px, 0px)",
            }}
            data-popper-placement="bottom-start"
          >
            <Link
              className="dropdown-item edit-popup"
              to="#"
              data-bs-toggle="offcanvas"
              data-bs-target="#edit_Pricebook"
              onClick={() => record.id && handleEditClick(record.id)}
            >
              <i className="ti ti-edit text-blue"></i> Edit
            </Link>

            <Link
              className="dropdown-item"
              to="#"
              data-bs-toggle="modal"
              data-bs-target="#delete_pricebook"
              onClick={() => record.id && handleDeleteClick(record.id, record.name)}
            >
              <i className="ti ti-trash text-danger"></i> Delete
            </Link>
          </div>
        </div>
      ),
    }
  ];

  // Thêm key duy nhất cho mỗi dòng dữ liệu
  const pricebooksWithKeys = data.map((pricebook, index) => ({
    ...pricebook,
    key: pricebook.id || index,
  }));

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <div className="col-md-12">
              <div className="page-header">
                <div className="row align-items-center">
                  <div className="col-8">
                    <h4 className="page-title">
                      Pricebooks<span className="count-title">{pagination.totalElements}</span>
                    </h4>
                  </div>
                  <div className="col-4 text-end">
                    <div className="head-icons">
                      <CollapseHeader />
                    </div>
                  </div>
                </div>
              </div>
              <div className="card ">
                <div className="card-header">
                  <div className="row align-items-center">
                    <div className="col-sm-4">
                      <div className="icon-form mb-3 mb-sm-0">
                        <span className="form-icon">
                          <i className="ti ti-search" />
                        </span>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Search pricebook"
                          name="name"
                          value={filters.name}
                          onChange={handleFilterChange}
                        />
                      </div>
                    </div>
                    <div className="col-sm-8">
                      <div className="d-flex align-items-center flex-wrap row-gap-2 justify-content-sm-end">
                        <div className="dropdown me-2">
                          <Link
                            to="#"
                            className="dropdown-toggle"
                            data-bs-toggle="dropdown"
                          >
                            <i className="ti ti-package-export me-2" />
                            Export
                          </Link>
                          <div className="dropdown-menu dropdown-menu-end">
                            <ul>
                              <li>
                                <Link to="#" className="dropdown-item">
                                  <i className="ti ti-file-type-pdf text-danger me-1" />
                                  Export PDF
                                </Link>
                              </li>
                              <li>
                                <Link to="#" className="dropdown-item">
                                  <i className="ti ti-file-type-xls text-green me-1" />
                                  Export Excel
                                </Link>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <Link
                          to="#"
                          className="btn btn-primary"
                          data-bs-toggle="offcanvas"
                          data-bs-target="#offcanvas_add"
                        >
                          <i className="ti ti-square-rounded-plus me-2" />
                          Add Pricebook
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="card-body">
                  <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2 mb-4">
                    <div className="d-flex align-items-center flex-wrap row-gap-2">
                      <div className="dropdown me-2">
                        <Link
                          to="#"
                          className="dropdown-toggle"
                          data-bs-toggle="dropdown"
                        >
                          <i className="ti ti-sort-ascending-2 me-2" />
                          Sort
                        </Link>
                        <div className="dropdown-menu dropdown-menu-start">
                          <ul>
                            <li>
                              <button className="dropdown-item" onClick={() => handleSortChange("name", "ASC")}>
                                <i className="ti ti-circle-chevron-right me-1" />
                                Ascending
                              </button>
                            </li>
                            <li>
                              <button className="dropdown-item" onClick={() => handleSortChange("name", "DESC")}>
                                <i className="ti ti-circle-chevron-right me-1" />
                                Descending
                              </button>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="d-flex align-items-center flex-wrap row-gap-2">
                      <div className="form-sorts dropdown me-2">
                        <Link
                          to="#"
                          data-bs-toggle="dropdown"
                          data-bs-auto-close="outside"
                        >
                          <i className="ti ti-filter-share" />
                          Filter
                        </Link>
                        <div className="filter-dropdown-menu dropdown-menu dropdown-menu-md-end p-3">
                          <div className="filter-set-view">
                            <div className="filter-set-head">
                              <h4>
                                <i className="ti ti-filter-share" />
                                Filter
                              </h4>
                            </div>
                            <div className="accordion" id="accordionExample">
                              <div className="filter-set-content">
                                <div className="filter-set-content-head">
                                  <Link
                                    to="#"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#collapseTwo"
                                  >
                                    Pricebook Name
                                  </Link>
                                </div>
                                <div
                                  className="filter-set-contents accordion-collapse collapse show"
                                  id="collapseTwo"
                                >
                                  <div className="filter-content-list">
                                    <input
                                      type="text"
                                      className="form-control"
                                      name="name"
                                      value={filters.name}
                                      onChange={handleFilterChange}
                                      placeholder="Enter pricebook name"
                                    />
                                  </div>
                                </div>
                              </div>

                              <div className="filter-reset-btns">
                                <div className="row">
                                  <div className="col-6">
                                    <button className="btn btn-light" onClick={() => setFilters((prevFilters) => ({
                                      ...prevFilters,
                                      name: "",
                                    }))}>
                                      Reset
                                    </button>
                                  </div>
                                  <div className="col-6">
                                    <button className="btn btn-primary" onClick={applyFilters}>
                                      Apply
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="view-icons">
                        <Link to="#" className="active">
                          <i className="ti ti-list-tree" />
                        </Link>
                        <Link to="#">
                          <i className="ti ti-grid-dots" />
                        </Link>
                      </div>
                    </div>
                  </div>

                  <div className="table-responsive custom-table">
                    <Table dataSource={pricebooksWithKeys} columns={columns} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal thêm mới Pricebook */}
      <div
        className="offcanvas offcanvas-end offcanvas-large"
        tabIndex={-1}
        id="offcanvas_add"
      >
        <div className="offcanvas-header border-bottom">
          <h5 className="fw-semibold">Add New Pricebook</h5>
          <button
            type="button"
            className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          >
            <i className="ti ti-x" />
          </button>
        </div>
        <div className="offcanvas-body">
          <form>
            <div className="accordion" id="main_accordion">
              <div className="accordion-item rounded mb-3">
                <div className="accordion-header">
                  <Link
                    to="#"
                    className="accordion-button accordion-custom-button bg-white rounded fw-medium text-dark"
                    data-bs-toggle="collapse"
                    data-bs-target="#basic"
                  >
                    <span className="avatar avatar-md rounded text-dark border me-2">
                      <i className="ti ti-shopping-cart fs-20" />
                    </span>
                    Basic Information
                  </Link>
                </div>
                <div
                  className="accordion-collapse collapse show"
                  id="basic"
                  data-bs-parent="#main_accordion"
                >
                  <div className="accordion-body border-top">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="mb-3">
                          <label className="col-form-label">
                            Pricebook Name <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="name"
                            value={newPricebook.name}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="d-flex align-items-center justify-content-end">
              <button
                type="button"
                data-bs-dismiss="offcanvas"
                className="btn btn-light me-2"
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleCreatePricebook}
              >
                Create
              </button>
            </div>
            <ResponseModal show={showMessageModal} onClose={() => setShowMessageModal(false)} response={response} />
          </form>
        </div>
      </div>

      {/* Modal chỉnh sửa Pricebook */}
      <div
        className="offcanvas offcanvas-end offcanvas-large"
        tabIndex={-1}
        id="edit_Pricebook"
      >
        <div className="offcanvas-header border-bottom">
          <h5 className="fw-semibold">Edit Pricebook</h5>
          <button
            type="button"
            className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          >
            <i className="ti ti-x" />
          </button>
        </div>
        <div className="offcanvas-body">
          <form>
            <div className="accordion" id="main_accordion_2">
              <div className="accordion-item rounded mb-3">
                <div className="accordion-header">
                  <Link
                    to="#"
                    className="accordion-button accordion-custom-button bg-white rounded fw-medium text-dark"
                    data-bs-toggle="collapse"
                    data-bs-target="#basic_edit"
                  >
                    <span className="avatar avatar-md rounded text-dark border me-2">
                      <i className="ti ti-shopping-cart fs-20" />
                    </span>
                    Basic Information
                  </Link>
                </div>
                <div
                  className="accordion-collapse collapse show"
                  id="basic_edit"
                  data-bs-parent="#main_accordion_2"
                >
                  <div className="accordion-body border-top">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="mb-3">
                          <label className="col-form-label">
                            Pricebook Name <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="name"
                            value={editingPricebook?.name}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="d-flex align-items-center justify-content-end">
              <button
                type="button"
                data-bs-dismiss="offcanvas"
                className="btn btn-light me-2"
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleUpdatePricebook}
              >
                Update
              </button>
            </div>
            <ResponseModal show={showMessageModal} onClose={() => setShowMessageModal(false)} response={response} />
          </form>
        </div>
      </div>

      {/* Modal xóa Pricebook */}
      <div className="modal fade" id="delete_pricebook" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className="text-center">
                <div className="avatar avatar-xl bg-danger-light rounded-circle mb-3">
                  <i className="ti ti-trash-x fs-36 text-danger" />
                </div>
                <h4 className="mb-2">Delete Pricebook?</h4>
                <p className="mb-0">
                  Are you sure you want to delete this pricebook?
                </p>
                <div className="d-flex align-items-center justify-content-center mt-4">
                  <Link
                    to="#"
                    className="btn btn-light me-2"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </Link>
                  <button
                    data-bs-dismiss="modal"
                    className="btn btn-danger"
                    onClick={handleConfirmDelete}
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal show={showProductsModal} onHide={() => setShowProductsModal(false)} size="lg" backdrop="static">
        <div className="modal-header border-0 m-0">
          <h5 className="modal-title">Products in {selectedPricebookName}</h5>
          <div>
            <button
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={() => setShowProductsModal(false)}
            >
              <i className="ti ti-x" />
            </button>
            <button
              type="button"
              className="btn btn-primary me-2"
              onClick={() => setShowAddProductModal(true)}
            >
              <i className="ti ti-plus me-1"></i>
              Add Product
            </button>

          </div>

        </div>
        <div className="modal-body">
          <div className="table-responsive">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th>Product Name</th>
                  <th>Price</th>
                  <th>Created By</th>
                  <th>Created Date</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {selectedPricebookProducts[0]?.productRelated.map((product) => (
                  <tr key={product.productId}>
                    <td>
                      <Link to={`/crm/products-details/${product.productId}`}>
                        {product.productName}
                      </Link>
                    </td>
                    <td>${product.productPrice}</td>
                    <td>{selectedPricebookProducts[0]?.createdBy}</td>
                    <td>{new Date(selectedPricebookProducts[0]?.createdAt).toLocaleDateString()}</td>
                    <td>
                      <div className="dropdown table-action">
                        <Link
                          to="#"
                          className="action-icon"
                          data-bs-toggle="dropdown"
                          aria-expanded="true"
                        >
                          <i className="fa fa-ellipsis-v"></i>
                        </Link>
                        <div
                          className="dropdown-menu dropdown-menu-right"
                          style={{
                            position: "absolute",
                            inset: "0px auto auto 0px",
                            margin: "0px",
                            transform: "translate3d(-99.3333px, 35.3333px, 0px)",
                          }}
                          data-popper-placement="bottom-start"
                        >
                          <Link
                            className="dropdown-item"
                            to="#"
                            onClick={() => handleEditProduct(product.productId)}
                          >
                            <i className="ti ti-edit text-blue"></i> Edit
                          </Link>

                          <Link
                            className="dropdown-item"
                            to="#"
                            onClick={() => handleDeleteProductFromPriceBook(product.id)}
                          >
                            <i className="ti ti-trash text-danger"></i> Delete
                          </Link>
                        </div>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-light"
            onClick={() => setShowProductsModal(false)}
          >
            Close
          </button>
        </div>
      </Modal>

      {/* Modal thông báo thành công khi tạo mới */}
      <Modal show={openModal} onHide={() => setOpenModal(false)}>
        <div className="modal-header border-0 m-0 justify-content-end">
          <button
            className="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            onClick={() => setOpenModal(false)}
          >
            <i className="ti ti-x" />
          </button>
        </div>
        <div className="modal-body">
          <div className="success-message text-center">
            <div className="success-popup-icon bg-light-blue">
              <i className="ti ti-medal" />
            </div>
            <h3>Pricebook has been created successfully!</h3>
            <p>View created pricebook details</p>
            <div className="col-lg-12 text-center modal-btn">
              <Link to="#" className="btn btn-light" data-bs-dismiss="modal" onClick={() => setOpenModal(false)}>
                Cancel
              </Link>
              <Link
                to={`/crm/pricebooks-details/${createdPricebookId}`}
                onClick={() => setOpenModal(false)}
                className="btn btn-primary"
              >
                OK
              </Link>
            </div>
          </div>
        </div>
      </Modal>

      {/* Modal thông báo thành công khi cập nhật */}
      <Modal show={openEditSuccessModal} onHide={() => setOpenEditSuccessModal(false)}>
        <div className="modal-body">
          <div className="success-message text-center">
            <div className="success-popup-icon bg-light-blue">
              <i className="ti ti-chart-arcs" />
            </div>
            <h3>Pricebook has been updated successfully!</h3>
            <div className="col-lg-12 text-center modal-btn">
              <Link
                to="#"
                onClick={() => {
                  setOpenEditSuccessModal(false);
                }}
                className="btn btn-primary"
              >
                OK
              </Link>
            </div>
          </div>
        </div>
      </Modal>
      {/* Modal Edit Product */}
      <Modal show={showEditProductModal} onHide={() => setShowEditProductModal(false)} backdrop="static" size="lg">
        <div className="modal-header border-bottom">
          <h5 className="modal-title">Edit Product</h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => setShowEditProductModal(false)}
          >
            <i className="ti ti-x" />
          </button>
        </div>
        <div className="modal-body">
          {loadingProductDetail ? (
            <div className="text-center p-4">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : (
            <form>
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="form-label">Product Name</label>
                  <input
                    type="text"
                    className="form-control"
                    name="productName"
                    value={editedProduct.productName}
                    onChange={handleInputUpdateProductChange}
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <label className="form-label">Product Price</label>
                  <input
                    type="text"
                    className="form-control"
                    name="productPrice"
                    value={editedProduct.productPrice}
                    onChange={handleInputUpdateProductChange}
                  />
                </div>
                <div className="col-md-12 mb-3">
                  <label className="form-label">Description</label>
                  <textarea
                    className="form-control"
                    value={editedProduct.productDescription}
                    name="productDescription"
                    onChange={handleInputUpdateProductChange}
                    rows={3}
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <label className="form-label">Category</label>
                  <input
                    type="text"
                    className="form-control"
                    name="productCategory"
                    value={editedProduct.productCategory}
                    onChange={handleInputUpdateProductChange}
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <label className="form-label">Code</label>
                  <input
                    type="text"
                    className="form-control"
                    name="productCode"
                    value={editedProduct.productCode}
                    onChange={handleInputUpdateProductChange}
                  />
                </div>
              </div>
            </form>
          )}
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-light"
            onClick={() => setShowEditProductModal(false)}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={handleUpdateProduct}
          >
            Update Product
          </button>
        </div>
      </Modal>
      <Modal
        show={showAddProductModal}
        onHide={() => setShowAddProductModal(false)}
        backdrop="static"
        size="lg"
      >
        <div className="modal-header border-bottom">
          <h5 className="modal-title">Add Products to {selectedPricebookName}</h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => setShowAddProductModal(false)}
          >
            <i className="ti ti-x" />
          </button>
        </div>
        <div className="modal-body">
          {loading ? (
            <div className="text-center p-4">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : (
            <>
              <div className="mb-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search products..."
                  onChange={(e) => {
                    // TODO: Implement search functionality
                    console.log("Search:", e.target.value);
                  }}
                />
              </div>
              <div className="table-responsive" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                <table className="table table-hover">
                  <thead className="table-light">
                    <tr>
                      <th style={{ width: '50px' }}>
                        <input
                          type="checkbox"
                          className="form-check-input"
                          checked={selectedProductIds.length === products.length}
                          onChange={(e) => {
                            if (e.target.checked) {
                              setSelectedProductIds(products.map(p => p.id));
                            } else {
                              setSelectedProductIds([]);
                            }
                          }}
                        />
                      </th>
                      <th>Product Name</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {products.map((product) => {
                      const isSelected = selectedProductIds.includes(product.id);
                      const isInPricebook = selectedPricebookProducts[0]?.productRelated
                        .some(p => p.productId === product.id);

                      return (
                        <tr key={product.id}>
                          <td>
                            <input
                              type="checkbox"
                              className="form-check-input"
                              checked={isSelected}
                              disabled={isInPricebook}
                              onChange={() => handleProductSelect(product.id)}
                            />
                          </td>
                          <td>{product.productName}</td>
                          <td>
                            {isInPricebook ? (
                              <span className="badge bg-light-warning">Already Added</span>
                            ) : (
                              <span className="badge bg-light-success">Available</span>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </>
          )}
        </div>
        <div className="modal-footer">
          <div className="d-flex align-items-center me-auto">
            <span className="text-muted">
              Selected: {selectedProductIds.length} products
            </span>
          </div>
          <button
            type="button"
            className="btn btn-light"
            onClick={() => setShowAddProductModal(false)}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={handleAddSelectedProducts}
            disabled={selectedProductIds.length === 0}
          >
            Next
          </button>
        </div>
      </Modal>
      {/* Modal Delete Product */}
      <Modal show={showDeleteProductModal} onHide={() => setShowDeleteProductModal(false)} backdrop="static">
        <div className="modal-body">
          <div className="text-center">
            <div className="avatar avatar-xl bg-danger-light rounded-circle mb-3">
              <i className="ti ti-trash-x fs-36 text-danger" />
            </div>
            <h4 className="mb-2">Delete Product?</h4>
            <p className="mb-0">
              Are you sure you want to delete {selectedProduct?.name}?
            </p>
            <div className="d-flex align-items-center justify-content-center mt-4">
              <button
                type="button"
                className="btn btn-light me-2"
                onClick={() => setShowDeleteProductModal(false)}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-danger"
                onClick={handleConfirmDeleteProduct}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      </Modal>
      {/* Modal nhập giá cho sản phẩm */}
      <Modal
        show={showPriceModal}
        onHide={() => setShowPriceModal(false)}
        backdrop="static"
        size="lg"
      >
        <div className="modal-header border-bottom">
          <h5 className="modal-title">Set Prices for Selected Products</h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => {
              setShowPriceModal(false);
              setShowAddProductModal(true); // Quay lại modal chọn sản phẩm
            }}
          >
            <i className="ti ti-x" />
          </button>
        </div>
        <div className="modal-body">
          <div className="table-responsive">
            <table className="table">
              <thead className="table-light">
                <tr>
                  <th>Product Name</th>
                  <th>Price</th>
                </tr>
              </thead>
              <tbody>
                {selectedProductsWithPrice.map((product) => (
                  <tr key={product.productId}>
                    <td>{product.productName}</td>
                    <td>
                      <div className="input-group" style={{ width: '200px' }}>
                        <span className="input-group-text">$</span>
                        <input
                          type="number"
                          className="form-control"
                          value={product.productPrice}
                          onChange={(e) => handlePriceChange(
                            product.productId,
                            parseFloat(e.target.value) || 0
                          )}
                          min="0"
                          step="0.01"
                          required
                        />
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-light"
            onClick={() => {
              setShowPriceModal(false);
              setShowAddProductModal(true); // Quay lại modal chọn sản phẩm
            }}
          >
            Back
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={handleAddProductsWithPrice}
            disabled={selectedProductsWithPrice.some(p => p.productPrice <= 0)}
          >
            Add Products
          </button>
        </div>
      </Modal>
      <ResponseModal show={showMessageModal} onClose={() => setShowMessageModal(false)} response={response} />
    </div>
  );
};

export default PricebookList; 